export default __webpack_public_path__ + "static/media/Path3408.c03700e8.svg";